import {AppComponentState} from "../../ui/app/AppReducer";
import {PledgerAction, TokenProvider} from "@pledger/frontend-commons";
import {store} from "../../ui/app/store";


export const noTokenProvider = (appComponentState : AppComponentState) => {
    const result : TokenProvider = (action: PledgerAction) => {
        return undefined;
    };
    return result;
}

export const enrollmentTokenProvider = (appComponentState : AppComponentState) => {
    const result : TokenProvider =  (action : PledgerAction) => {
        const context = store.getState().appContext;
        const enrollmentToken = context.enrollmentToken;
        return enrollmentToken;
    };
    return result;
}

export const userTokenProvider = (appComponentState : AppComponentState) => {
    const result : TokenProvider =  (action : PledgerAction) => {
        const context = store.getState().appContext;
        const userToken = context.userToken;
        return userToken;
    };
    return result;
}


export const resetPasswordTokenProvider = () => {
    return (action : PledgerAction) => {
        return action.payload.resetToken;
    }
};
